import { maxLength } from "./validators";
import { invalidCharacters } from "utils/common";
import { checkDTreeNameAvailable } from "reducers/DTrees";

const DTREE_NAME_PATTERN = /^[ ,a-zA-Z0-9_+-~]+$/;
const DTREE_NAME_MAX_LENGTH = 250;


export function dtreeNameAllowedChars(value){
	const invalidCharactersFunc = invalidCharacters(DTREE_NAME_PATTERN, value);
	const NAME_ERROR_MESSAGE = `${invalidCharactersFunc.join(" ")} ${invalidCharactersFunc.length > 1 ? 'are' : 'is'} not permitted in Decision Tree names`;
	return invalidCharactersFunc.length ? NAME_ERROR_MESSAGE : undefined;
}

export const dtreeNameMaxLength = maxLength(DTREE_NAME_MAX_LENGTH);

export async function dtreeNameExists(dispatch, libraryId, newDTreeName, fieldName){
	let response = await dispatch(checkDTreeNameAvailable(libraryId, newDTreeName));

	if(!response?.success){
		return {
			[fieldName]:response.description,
		};
	}
	return undefined;
}
